<script>
import Pictures from '@wielink-application/shared/vue/components/form/input-only/pictures.vue';
export default Pictures;
</script>